import { Identifiable, Resource as R, ResourceTypes } from "@planzone/dto";
import { SortFunctions, SortOption } from "./types";

const defaultSort = (data: Identifiable<R>[]): Identifiable<R>[] => {
  return [...data]
    .sort((a, b) => a.name.localeCompare(b.name))
    .sort((a, b) => {
      const priority = {
        [ResourceTypes.HUMAN]: 1,
        [ResourceTypes.VIRTUAL]: 2,
        [ResourceTypes.MATERIAL]: 3,
      };

      return priority[a.type] - priority[b.type];
    });
};

const nameSort = (data: Identifiable<R>[]): Identifiable<R>[] => {
  return [...data].sort((a, b) => a.name.localeCompare(b.name));
};

const roleSort = (data: Identifiable<R>[]): Identifiable<R>[] => {
  return [...data].sort((a, b) => {
    if (a.type === ResourceTypes.MATERIAL) return 1;
    return a.role?.name.localeCompare(b.role?.name ?? "z") ?? -1;
  });
};

const creationSort = (data: Identifiable<R>[]): Identifiable<R>[] => {
  return [...data].sort((a, b) => {
    const dateA = new Date(a.createdDate);
    const dateB = new Date(b.createdDate);
    if (dateA > dateB) return 1;
    if (dateA < dateB) return -1;
    return 0;
  });
};

const sortFunctions: SortFunctions = {
  [SortOption.Default]: (data: Identifiable<R>[]) => {
    return defaultSort(data);
  },
  [SortOption.NAME]: (data: Identifiable<R>[]) => {
    return nameSort(data);
  },
  [SortOption.Role]: (data: Identifiable<R>[]) => {
    return roleSort(data);
  },
  [SortOption.CreationDate]: (data: Identifiable<R>[]) => {
    return creationSort(data);
  },
};

const applySorters = (
  data: Identifiable<R>[],
  sorter: SortOption,
): Identifiable<R>[] => {
  return sortFunctions[sorter](data);
};

export { applySorters };
